// import { useMutation, useQuery } from "@tanstack/react-query";
import {  useQuery } from '@tanstack/react-query';
import { useChoiceListApi } from '../../Hooks/useChoiceListApi';


type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  storeId?: string;
};
export const useChoiceList = (queryParams: Params) => {

  const { getChoiceList } = useChoiceListApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getChoiceGroup',queryParams],
    queryFn: () => {
      return getChoiceList(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};


